import React, { useState } from 'react';
import config from '../../config.json';
import { ShopContainer, ShopHeader, ShopContent, ShopButton, Overlay, WarningDialog, ButtonGroup, Button } from './Shop.Styles';


const Shop: React.FC = () => {
  const [showWarning, setShowWarning] = useState(false);
  const storeUrl = config.shopify.storeUrl;

  const handleShopClick = () => {
    setShowWarning(true);
  };

  const handleContinue = () => {
    window.open(storeUrl, '_blank', 'noopener,noreferrer');
    setShowWarning(false);
  };

  const handleCancel = () => {
    setShowWarning(false);
  };

  return (
    <ShopContainer>
      <ShopHeader>
        <h1>Tigers Official Store</h1>
        <p>Browse and purchase official Tigers merchandise and gear. All products are fulfilled by our trusted partner Jersey53.</p>
      </ShopHeader>

      <ShopContent>
        <ShopButton onClick={handleShopClick}>
          Visit Our Store
        </ShopButton>
      </ShopContent>

      <Overlay $isVisible={showWarning} onClick={handleCancel} />
      <WarningDialog $isVisible={showWarning}>
        <h2>Leaving Tigers Website</h2>
        <p>You are about to be redirected to our merchandise supplier, Jersey53. Would you like to continue?</p>
        <ButtonGroup>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button $variant="primary" onClick={handleContinue}>Continue to Store</Button>
        </ButtonGroup>
      </WarningDialog>
    </ShopContainer>
  );
};

export default Shop; 